import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/Navigation.css';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src="/images/CruxLabs_logo.png" alt="CruxLabs" />
        </Link>
        
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/map" 
            className={`nav-link ${isActive('/map') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            The Map
          </Link>
          <Link 
            to="/models" 
            className={`nav-link ${isActive('/models') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Latest Models
          </Link>
          <Link 
            to="/premium" 
            className={`nav-link ${isActive('/premium') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Get Premium
          </Link>
          <Link 
            to="/collaborate" 
            className={`nav-link ${isActive('/collaborate') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Collaborate
          </Link>
          <Link 
            to="/contact" 
            className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </Link>
          <Link 
            to="/account" 
            className="nav-link nav-cta"
            onClick={() => setIsMenuOpen(false)}
          >
            Join CruxLabs
          </Link>
        </div>

        <div className="nav-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;